/* TODO: remove language entries
	Example: Translation.translate('KEY', { param1: 1, param2: 2 });
	'OWN_MESSAGE_PAGE_PDF_PREFLIGHT_IN_PROGRESS'
	'OWN_MESSAGE_PAGE_PDF_RETRY_FAIL_MESSAGE'
	'OWN_MESSAGE_PAGE_PDF_PAGES_EXCEEDED_MESSAGE'
	'OWN_MESSAGE_PAGE_PDF_PAGES_EXCEEDED_MAX_PAGES'
	'OWN_MESSAGE_PREFACE_PAGE_INFO'
	'OWN_MESSAGE_NUMBER_OF_PAGES_IN_DOCUMENT'
	'OWN_MESSAGE_FONT'
	'OWN_MESSAGE_IMAGES_OK'
	'OWN_MESSAGE_IMAGES_WARNING'
	'OWN_MESSAGE_SIZE_LIMIT_EXCEEDED'
	'OWM_MESSAGE_UNSUPPORTED_RESOLUTION'
	'OWN_MESSAGE_INCONSISTENT_RESOLUTION'
	'OWN_MESSAGE_PAGE_LIMIT_EXCEEDED'
	'OWN_MESSAGE_PAGE_PDF_PREFLIGHT_RESULT'
	'OWN_MESSAGE_VALIDATION_FAILURE'
	'OWN_MESSAGE_PAGE_TIMEOUT_ERROR'
    'OWN_MESSAGE_PAGE_INVALID_FORMAT'
*/

(function () {
  'use strict';

  angular
    .module('web2print.message')
    .directive('ownMessageForm', ownMessageForm);

  /* @ngInject */
  function ownMessageForm () {
    return {
      restrict: 'E',
      templateUrl: 'components/message/own-message.directive.html',
      scope: {
        'sendoutName': '=',
        'approved': '='
      },
      link: function (scope, element, attrs) {
        scope.name = attrs.name;
      },
      controller: OwnMessageFormController,
      controllerAs: 'ownMessageForm',
      bindToController: true
    };
  }

  OwnMessageFormController.$inject = ['$http', '$sce', '$filter', '$q', 'Common', 'Translation', 'FileUpload',
    'Upload', 'FileDownload', 'MessageProxy', 'Browser', 'whereToFactory', 'FeatureToggleFactory', '$timeout'];

  /* @ngInject */
  function OwnMessageFormController ($http, $sce, $filter, $q, Common, Translation, FileUpload, Upload, FileDownload,
    MessageProxy, Browser, whereToFactory, FeatureToggleFactory, $timeout) {
    // === Utility:
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    function getUniqueUrl (url) {
      return url + '?' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    // ==== Fields:
    const vm = this;

    // Feature Toggle
    // TODO: remove when ready for prod
    vm.showMaterialSampleLink = FeatureToggleFactory.isFeatureEnabled('materialDownloadLink');

    // END Feature Toggle

    // ==== Exposed (public) functions:
    vm.startUpload = startUpload;
    vm.removeAttachment = removeAttachment;
    vm.hideInformation = hideInformation;
    vm.getShowResultVal = getShowResultVal;
    vm.openHumanyGuide = openHumanyGuide;
    vm.checkedSVGPath = getUniqueUrl('assets/images/ic_check_black_24px.svg');
    vm.deleteSVGPath = getUniqueUrl('assets/images/ic-delete.svg');
    vm.serviceType = Common.get('serviceType', 'information');

    vm.dottedLines = serviceInList(['information', 'paymentSlips', 'admail-letter', 'admail-postcard']);
    vm.dottedWindows = serviceInList(['information', 'paymentSlips', 'admail-letter']);
    vm.dottedFringe = serviceInList(['admail-letter', 'admail-postcard']);
    vm.dottedWindowsAndFringe = serviceInList(['admail-letter']);
    const context = vm.context = getProcessContext();

    // ==== Runtime:
    init();

    // ==== Private functions:

    /**
		 * Initialize the state of a running directive
		 */
    function init () {

      if (Common.get('s3Pdf', false)) {
        // If prestine changes have been made, thus need to regenerate the preview with these
        if (!Common.get('changedAddress', false) && Common.exists('pristine', false) && (whereToFactory.preface === Common.get('preface', false)) && !whereToFactory.productChanged) {
          // Just display the current preview
          displayPreview()
            .catch(function (error) {
              displayError('PDF_VALIDATION_DISPLAY_ERROR');
            });
        } else {
          // Generate and display new preview
          if (Common.get('changedAddress', false) || (whereToFactory.preface !== Common.get('preface', false))
            || whereToFactory.productChanged) {
            whereToFactory.productChanged = false;
            whereToFactory.preface = Common.get('preface', false);
            Common.remove('changedAddress');

            if (Common.get('pdfApproved', false) || Common.get('materialDetails', false)) {
              Common.notifyObserver('changePdfApproved', vm.approved = null);
              Common.set('materialDetails', null);
              Common.set('pdfApproved', null);
              validate()
                .then(generatePreview)
                .then(displayPreview)
                .catch(function (error) {
                  Common.set('materialFolderId', null);
                  displayError(error);
                });
            }

          } else {
            if (Common.get('pdfApproved', false)) {
              generatePreview()
                .then(displayPreview)
                .catch(function (error) {
                  displayError('PDF_VALIDATION_GENERATE_ERROR');
                });
            }
          }
        }
      }
    }

    function serviceInList (list) {
      const serviceType = Common.get('serviceType');
      return list.indexOf(serviceType) >= 0;
    }

    function getShowResultVal () {
      return vm.showResults;
    }

    /**
		 * Triggered when an upload has been initiated an user, either by dropping a file in content area or
		 * clicking and selected file in browser.
		 * @param {*} files
		 * @param {*} invalid
		 */
    function startUpload (files, invalid) {
      context.error = null;

      if (!(context.pdf.validFormat = files.length > 0)) {
        return displayError('PDF_VALIDATION_INVALID_FILE');
      }

      const file = Upload.rename(context.pdf.file = files[0], 'material.pdf');

      // Quick excape if size is larger than 50 mebibyte, note that size is also validated on backend
      const size = Math.round(file.size / Math.pow(2, 20));
      if (size > 50) {
        // TODO: show as error now, maybe display it somewhere else?
        return Translation.translate('OWN_MESSAGE_SIZE_LIMIT_EXCEEDED', {
          limit: 50,
          current: size
        }).value;
      }

      Common.set('pdfFileName', file.name);


      upload(file) // Upload pdf file and trigger preflight validation
          .then(parseMaterial) // Do validation and flatten pdf
          .then(generatePreview) // Generate a sneak peek of end result
          .then(displayPreview) // Download and display preview
          .catch(function (error) {
            return displayError(error);
          }); // Any errors that will occur
    }

    function parseMaterial () {
      return new Promise(function (resolve, reject) {
        context.status.state = Translation.translate('OMM_MESSAGE_PREVALIDATION');
        context.status.done = false;

        const format = Common.get('productDelivery').format;
        const materialFolderId = Common.get('materialFolderId');

        MessageProxy.validateMaterial(materialFolderId, {
          width: format.width,
          height: format.length,
          name: format.name
        }, {
          preface: Common.get('preface', false),
          singleSided: Common.get('singleSided', true)
        }).then(function (result) {
          const details = getDetails(result);
          const validation = getValidation(details);

          if (validation.valid) {
            if (validation.flatteningRequired) {
              context.status.state = Translation.translate('OWN_MESSAGE_FLATTEN');
              MessageProxy.flattenMaterial(materialFolderId).then(function () {
                context.details = details;
                context.result = validation.result;
                context.valid = validation.valid;
                context.flatteningResult = validation.flatteningResult;

                Common.set('materialDetails', context.details);
                return resolve();
              }).catch(function (reason) {
                console.error(reason);
                return reject('PDF_FLATTENING_FAILED');
              });
            } else {
              context.details = details;
              context.result = validation.result;
              context.valid = validation.valid;

              Common.set('materialDetails', context.details);
              return resolve();
            }
          } else {
            context.result = validation.result;
            context.valid = validation.valid;

            console.info('invalid file');
            return reject('invalidFile'); //does not matter as long as it is not empty
          }
        }).catch(function (reason) {
          console.error(reason);
          return reject('PDF_PARSING_ERROR'); //does not matter as long as it is not empty
        });
      });
    }

    /**
		 * Does the actual upload of pdf file to S3.
		 * @param {*} file A pdf file to be uploaded
		 */
    function upload (file) {
      return $q(function (resolve, reject) {
        vm.showResults = false;
        context.status.state = Translation.translate('OWN_MESSAGE_PAGE_PDF_UPLOADING');
        context.status.process = '0';
        context.status.done = false;

        function callback (process) {
          context.status.process = '' + process;
        }

        MessageProxy.uploadMaterial(file, callback)
          .then(function (response) {
            context.status.process = null;
            const folder = response.config.folder.split('/')[1];
            Common.set('materialFolderId', folder);
            Common.set('pdf', 'preview/' + folder + '/material.pdf');
            Common.set('uploadDateTime.pdf', moment());
            resolve();
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }

    /**
		 * Display any occurring error or failed validation to user.
		 * NOTE: translated messages should be done before.
		 * @param {*} message Message to be displayed to client.
		 */
    function displayError (message) {
      if (message === 'invalidFile') {
        vm.showResults = true;
        message = null; // set it to null so that the error balloon wont show
        context.status.state = null;
      } else {
        reset();
      }

      if (message)
        context.error = message;

      if (message && message.message) {
        context.error = message.message;
      }
    }

    function hideInformation () {
      Common.set('hidePDFInformationCard', context.hideInformationCard = true);
    }

    /**
		 * Additional validation on PDF to indicate user of any non supporting peculiarities.
		 */
    function validate () {
      return $q(function (resolve, reject) {
        context.status.state = Translation.translate('OMM_MESSAGE_PREVALIDATION');
        context.status.done = false;

        const format = Common.get('productDelivery').format;

        MessageProxy.validateMaterial(Common.get('materialFolderId'), {
          width: format.width,
          height: format.length,
          name: format.name
        }, {
          preface: Common.get('preface', false),
          singleSided: Common.get('singleSided', true)
        })
          .then(function (result) {
            const details = getDetails(result);
            const validation = getValidation(details);

            context.result = validation.result;
            context.valid = validation.valid;
            context.flatteningResult = validation.flatteningResult;

            // We do not use the validity from the result as the user might change settings that
            // might increase the pages, so do a "weak" additional validation on this,
            // alternatively is to run another preflight validation on pdf
            if (context.valid) {
              Common.set('materialDetails', context.details);
              return resolve();
            }
            return reject('invalidFile'); //does not matter as long as it is not empty
          })
          .catch(function () {
            return reject('PDF_VALIDATION_VALIDATION_ERROR'); //does not matter as long as it is not empty
          });
      });
    }

    function getValidation (details) {
      const productDelivery = Common.get('productDelivery');

      const exists = Translation.translate('OWN_MESSAGE_EXISTS');
      const imgResolutionLow = Translation.translate('OWN_MESSAGE_TOO_LOW');
      const imgResolutionPass = Translation.translate('OWN_MESSAGE_PASS');
      const embedded = Translation.translate('OWN_MESSAGE_EMBEDDED');
      const notEmbedded = Translation.translate('OWN_MESSAGE_NOT_EMBEDDED');
      const max = Translation.translate('OWN_MESSAGE_MAX');
      const shouldBe = Translation.translate('OWN_MESSAGE_SHOULD_BE');
      const incorrectPdfSize = Translation.translate('W2P_OWN_MESSAGE_INCORRECT_PDF_INFO');
      const inconsistentRequired = Translation.translate('OWN_MESSAGE_INCONSISTENT_PAGE_FORMAT');
      const pagesShouldBe = Translation.translate('OWN_MESSAGE_PAGES_SHOULD_BE', {
        pagesCount: productDelivery.page_count.base
      });
      const pdfNotAllowed = Translation.translate('OWN_MESSAGE_PDF_NOT_ALLOWED');

      const result = [];
      const flatteningResult = [];

      function pushToFlatteningResult (error) {
        // For feature toggle, remove when feature is in prod
        if (details.flatteningRequired) {
          flatteningResult.push(error);
        }
      }

      const pageFormats = {
        A4: Translation.translate('A4_FORMAT').value,
        A4Margin: Translation.translate('A4_MARGIN_FORMAT').value,
        A5LyingMargin: Translation.translate('A5_LYING_MARGIN').value
      };

      const fileSize = {
        label: Translation.translate('OWN_MESSAGE_PREFLIGHT_FILE_SIZE_CURRENT', {
          current: details.size.current
        }),
        required: details.size.valid ? '' : max.value + ' 50MB', // no need for size information if the pdf is ok
        valid: details.size.valid ? 1 : 2
      }; // sv: Filstorlek (Max 20mb)

      let pageFormat = {};
      let interactiveObjects;

      if (!details.pageFormat.error || details.pageFormat.error === 'unsupported') { //no error or unsupported has the same handling
        pageFormat = {
          label: Translation.translate('OWN_MESSAGE_PREFLIGHT_PAGE_FORMAT_CURRENT', {
            current: details.pageFormat.fileFormat
          }),
          required: !details.pageFormat.valid ? `${shouldBe.value} ${pageFormats[details.pageFormat.formatName]}. ${incorrectPdfSize.value}` : null,
          valid: details.pageFormat.valid ? 1 : 2
        }; // sv: Sidoresolution (A4/A4L, A5/A5L)
      } else { //pages of different format, should the error be something else it will not be handled
        pageFormat = {
          label: Translation.translate('OWN_MESSAGE_PREFLIGHT_PAGE_FORMAT_INCONSISTENT'),
          required: inconsistentRequired.value,
          valid: 2
        };
      }

      let pagesRequired = '';
      if (details.numberOfPagesUnderLimit && productDelivery.page_count.base === productDelivery.page_count.max) {
        pagesRequired = pagesShouldBe.value;
      } else if (details.numberOfPagesExceeded !== 0) {
        pagesRequired = max.value + ' ' + productDelivery.page_count.max;
      }

      const amountOfPages = {
        label: Translation.translate('OWN_MESSAGE_PREFLIGHT_PAGE_LIMIT_CURRENT', {
          current: details.numberOfPages.current
        }),
        required: pagesRequired,
        valid: details.numberOfPagesExceeded === 0 && !details.numberOfPagesUnderLimit ? 1 : 2,
        preface: Common.get('preface', false),
        prefacePage: Common.get('singleSided', false) ? 1 : 2
      }; // sv: Antal sidor (Max 20)

      result.push(fileSize, pageFormat, amountOfPages);

      const imageResolutions = {
        label: Translation.translate('OWN_MESSAGE_PREFLIGHT_IMAGE_RESOLUTION_CURRENT', {
          current: details.images.resolution ? imgResolutionPass.value : imgResolutionLow.value
        }),
        required: details.images.resolution ? '' : shouldBe.value + ' 300 dpi', // no need for dpi information if the pdf is ok
        valid: details.images.resolution ? 1 : 3
      }; // sv: Bildupplösning (Minst 300dpi)

      if (imageResolutions.valid !== 1) { // only display on error
        result.push(imageResolutions);
      }

      if (!details.rotation) {
        const rotation = {
          label: Translation.translate('OWN_MESSAGE_PREFLIGHT_ROTATION_CURRENT'),
          valid: 2
        };

        result.push(rotation);
      }

      const embeddedFonts = {
        label: Translation.translate('OWN_MESSAGE_PREFLIGHT_EMBEDDED_FONT_CURRENT', {
          current: details.embeddedFonts ? embedded.value : notEmbedded.value
        }),
        valid: details.embeddedFonts ? 1 : 2
      }; // sv: Inbäddade fonter

      if (details.embeddedFonts.valid !== 1 && details.embeddedFonts.errors && details.embeddedFonts.errors.length) {
        const errorTypes = {
          'TrueType': 'OWN_MESSAGE_PAGE_NOT_TRUETYPE',
          'SystemFont': 'OWN_MESSAGE_PAGE_FONT_NOT_RECOGNIZED',
          'NoDescriptor': 'OWN_MESSAGE_PREFLIGHT_EMBEDDED_FONT_CURRENT'
        };

        details.embeddedFonts.errors.forEach(function (item) {
          const error = {
            label: Translation.translate(errorTypes[item.errorType], {
              font: item.font
            }),
            valid: 3
          };
          pushToFlatteningResult(error);
        });
      } else if (embeddedFonts.valid !== 1) {
        pushToFlatteningResult(embeddedFonts);
      }

      if (details.images.transparency) {
        const imageTransparancy = {
          label: Translation.translate('OWN_MESSAGE_PREFLIGHT_IMAGE_TRANSPARENCY_CURRENT', {
            current: exists.value
          }),
          valid: 3
        }; // sv: Transparenta bilder
        pushToFlatteningResult(imageTransparancy);
      }

      if (details.interactive.valid === 'flatten') {
        const interactiveObjects = {
          label: Translation.translate('OWN_MESSAGE_PREFLIGHT_DISALLOWED_ELEMENTS_CURRENT', {
            current: exists.value
          }),
          required: pdfNotAllowed.value,
          valid: 3
        };
        pushToFlatteningResult(interactiveObjects);
      }

      if (!details.objects) {
        interactiveObjects = {
          label: Translation.translate('OWN_MESSAGE_PREFLIGHT_OBJECTS_EXCEED', {
            limit: '25.000'
          }),
          valid: 3
        };
        pushToFlatteningResult(interactiveObjects);
      }

      // TODO: make a condition when if it is true, it will set the amount of objects results
      // NOTE: checker for the amount of object is still not available in backend

      const valid = result.every(function (element) {
        return element.valid && element.valid !== 2;
      });

      return {
        result: result,
        valid: valid,
        flatteningResult,
        flatteningRequired: details.flatteningRequired
      };
    }

    /**
     * Add extra properties depending on existing properties.
     * @param {*} details Details to apply extra properties upon
     */

    function getValue (obj, key) {
      return obj && obj[key] ? obj[key] : 0;
    }

    function getDetails (result) {
      let details = null;
      if (result) {

        details = {
          // sendoutName: value (set and used outside of this scope)
          embeddedFonts: {
            valid: result.embeddedFonts.valid,
            errors: result.embeddedFonts.errorDetails
          },
          numberOfPages: {
            original: result.pageLimit.originalCount,
            current: result.pageLimit.current
          }, // Property is used outside of this scope
          size: result.sizeLimit,
          pageFormat: {
            format: getValue(result.resolution.format, 'width') + 'x' + getValue(result.resolution.format, 'height') + 'mm',
            valid: result.resolution.valid,
            error: result.resolution.error,
            formatName: (result.resolution.format || {}).name || Common.get('productDelivery').format.name,
            fileFormat: getValue(result.resolution.fileFormat, 'width') + 'x' + getValue(result.resolution.fileFormat, 'height') + 'mm'
          },
          images: {
            resolution: result.images.resolution,
            transparency: result.images.transparency
          },
          interactive: result.interactiveObjects,
          objects: result.objects.valid,
          rotation: result.rotation.valid,
          flatteningRequired: result.flatteningRequired
        };
      } else {
        details = Common.get('materialDetails');
      }

      if (details) {
        Object.defineProperties(details, {
          'maxNumberOfPages': {
            get: function () {
              return Common.get('productDelivery').page_count.max;
            },
            configurable: true
          },
          'minNumberOfPages': {
            get: function () {
              return Common.get('productDelivery').page_count.base;
            },
            configurable: true
          },
          'hasPageLimitExceeded': {
            get: function () {
              return details.numberOfPages > this.maxNumberOfPages;
            },
            configurable: true
          },
          'numberOfPagesExceeded': {
            get: function () {
              return Math.max(0, details.numberOfPages.current - this.maxNumberOfPages);
            },
            configurable: true
          },
          'numberOfPagesUnderLimit': {
            get: function () {
              return details.numberOfPages.current < this.minNumberOfPages;
            },
            configurable: true
          }
        });
      }
      return details;
    }

    /**
     * Generate a preview of end result to user (without black pages).
     */
    function generatePreview () {
      return $q(function (resolve, reject) {
        context.status.state = Translation.translate('OWN_MESSAGE_GENERATE_PDF_PREVIEW');
        context.status.process = '0';
        context.status.done = false;

        const options = MessageProxy.generatePreviewParams();

        function callback (finished, state) {
          if (finished && state === -1) {
            throw 'An error occurred while generating preview';
          }
          context.status.process = '' + (state === -1 ? 0 : state * 100);
        }

        MessageProxy.generatePreview(options, callback)
          .then(function (url) {
            // vm.content = $sce.trustAsResourceUrl(response.message);
            context.status.process = null;
            Common.set('s3Pdf', url);
            Common.set('pristine', true);
            resolve();
          })
          .catch(function (error) {
            reject(error ? error : 'Could not determine file existance');
          });
      });
    }

    /**
     * Download and display preview to client.
     */
    function displayPreview () {
      return $q(function (resolve, reject) {
        context.status.state = Translation.translate('OWN_MESSAGE_LOADING_PDF_PREVIEW');
        context.status.done = false;

        // Check if IE
        if (Browser.checkIEVersion()) {
          // Set s3Pdf URL as content
          vm.content = $sce.trustAsResourceUrl(Common.get('s3Pdf'));
          vm.showResults = true;
          setPdfStatusSuccess();
          resolve();
        } else {
          // If not IE, download PDF and set as content
          MessageProxy.getPdfContent(Common.get('s3Pdf'))
            .then(function (response) {
              const fileURL = URL.createObjectURL(new Blob([response], {
                type: 'application/pdf'
              }));
              vm.content = $sce.trustAsResourceUrl(fileURL);
              vm.showResults = true;
              setPdfStatusSuccess();
              resolve();
            })
            .catch(function (error) {

              // re-generate preview
              if (error.status === 400) {
                generatePreview()
                .then(displayPreview)
                .catch(function (error) {
                  reject(error);
                });
              } else {
                reject(error);
              }
            });
        }
      });
    }

    /**
     * Sets statuses to successful
     */
    function setPdfStatusSuccess () {
      context.status.state = null;
      context.status.done = context.successful = true;

      // The observer will set the value in session storage, see details in "changedPdfApproved" in "message.controller.js"
      Common.notifyObserver('changePdfApproved', vm.approved);
      Common.notifyObserver('web2print.pricing');
    }

    /**
     * Reset state of directive.
     */
    function reset () {
      context.status.done = false;
      context.successful = false;
      vm.showResults = false;

      delete context.status.state;
      delete context.error;
      delete context.details;
      delete context.valid;
      delete context.flatteningResult;

      Common.notifyObserver('changePdfApproved', vm.approved = false);

      vm.sendoutName = undefined;
      vm.errorResolution = false;
      vm.result = [];
    }

    /**
     * Remove attached pdf file and reset state of directive.
     */
    function removeAttachment () {
      Common.remove('s3Pdf');
      Common.remove('materialDetails');
      Common.set('uploadDateTime.pdf', undefined);

      context.pdf.file = null;

      Common.notifyObserver('web2print.pricing');
      Common.notifyObserver('updateSidePanelDetails');
      reset();
    }

    /**
     * Get processing context for initiate and activating the directive.
     * @param {Object} Common
     */
    function getProcessContext () {
      const details = getDetails();
      const contextValue = {
        processed: false,
        status: {
          state: null,
          done: false
        },
        details: details,
        hideInformationCard: Common.get('hidePDFInformationCard', false),
        pdf: {
          file: Common.exists('pdfFileName') ? {
            name: Common.get('pdfFileName')
          } : null,
          // progress: 0, TODO: remove? seems unused
          validFormat: true
        }

      };

      if (Common.get('materialDetails', false)) {
        const validation = getValidation(details);
        contextValue.result = validation.result;
        contextValue.valid = validation.valid;
        contextValue.flatteningResult = validation.flatteningResult;
      }

      return contextValue;
    }

    /**
     * Open humany guide base on product
     */
    function openHumanyGuide () {
      const faqElem = angular.element('<floating-faq></floating-faq>');
      const lang = pnTopbar.language;
      const productType = vm.serviceType;
      const faqPages = {
        letterA4: {
          en: '/11666/',
          sv: '/11660/'
        },
        adLetters: {
          en: '/11667/',
          sv: '/11664/'
        },
        adPostcards: {
          en: '/11665/',
          sv: '/11655/'
        }
      };
      const faqProductMap = {
        'information': faqPages.letterA4,
        'paymentSlips': faqPages.letterA4,
        'admail-letter': faqPages.adLetters,
        'admail-flyers': faqPages.adLetters,
        'admail-postcard': faqPages.adPostcards
      };

      const widgetName = `w2p-floating-${lang}`;
      const humanyName = `${faqProductMap[productType][lang]}ett-namn`;

      Humany.Widgets.Coordinator.trigger(faqElem, { widgetName: widgetName, activate: true },
        function () {
          Humany.navigate(`w2p-floating-${lang}`, humanyName);
        });
    }
  }
})();
